import { Dialog as BaseDialog } from '@base-ui/react/dialog';

import { cn } from '@/lib/cn';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const DialogTitle = ({ children, className }: Props) => {
  return (
    <BaseDialog.Title className={cn('text-lg font-semibold', className)}>
      {children}
    </BaseDialog.Title>
  );
};

export default DialogTitle;
